import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Denounce } from '../../../core/models/denounce.model';
import { Component, Inject, OnInit } from '@angular/core';
import { UtilsService } from '../../../core/services/utils.service';
import { ComplaintsService } from '../../../core/services/complaints.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-modal-status-confirm',
	templateUrl: './modal-status-confirm.component.html',
	styleUrls: ['./modal-status-confirm.component.scss'],
})
export class ModalStatusConfirmComponent implements OnInit {
	denounce: Denounce;
	depoimento: String;
	public loading = true;

	private denounceId: string;
	private readMoreWrapper = false;
	private menuActions: boolean;
	private confirmedUser: boolean;

	user = {
		gender: '',
		age: 0,
	};

	constructor(
		public utils: UtilsService,
		private toastr: ToastrService,
		private complaintsService: ComplaintsService,
		public dialogRef: MatDialogRef<ModalStatusConfirmComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.denounce = this.data['denounce'];
	}

	ngOnInit(): any {
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	putStatusDenounce(): void {
		this.complaintsService.putStatusDenounce(this.data.selectedValue, this.data.denounceId).subscribe((response) => {
			this.toastr.success('Status alterado com sucesso.');
		});
		this.closeModal();
	}



}
